import React, { useState, useEffect } from 'react';
import './CountdownTimer.scss';

const CountdownTimer = ({ text, seconds, onCountdownFinished }) => {
    const [count, setCount] = useState(seconds);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        // Exit if the count reaches 0
        if (count === 0) {
            // Invoke the callback when the countdown reaches 0
            if (onCountdownFinished) {
                onCountdownFinished();
            }
            return;
        }

        // Update the count every second
        const timer = setInterval(() => {
            setCount((prevCount) => {
                const newCount = prevCount - 1;
                // Trigger animation when count changes
                setIsAnimating(true);
                setTimeout(() => setIsAnimating(false), 300);
                return newCount;
            });
        }, 1000);

        // Clean up the timer when the component unmounts or count reaches 0
        return () => clearInterval(timer);
    }, [count, onCountdownFinished]);

    // Format seconds into a readable time format (e.g., 00:00)
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    // Calculate progress percentage for the circular timer
    const progress = ((seconds - count) / seconds) * 100;

    return (
        <div className="countdown-timer">
            <div className="countdown-timer__text">
                {text}
            </div>
            
            <div className="countdown-timer__container">
                {/* Circular Progress Ring */}
                <div className="countdown-timer__ring">
                    <svg className="countdown-timer__svg" viewBox="0 0 100 100">
                        {/* Background circle */}
                        <circle
                            className="countdown-timer__bg-circle"
                            cx="50"
                            cy="50"
                            r="45"
                            fill="none"
                            stroke="rgba(255, 255, 255, 0.1)"
                            strokeWidth="8"
                        />
                        {/* Progress circle */}
                        <circle
                            className="countdown-timer__progress-circle"
                            cx="50"
                            cy="50"
                            r="45"
                            fill="none"
                            stroke="url(#gradient)"
                            strokeWidth="8"
                            strokeLinecap="round"
                            strokeDasharray={`${2 * Math.PI * 45}`}
                            strokeDashoffset={`${2 * Math.PI * 45 * (1 - progress / 100)}`}
                            style={{
                                transition: 'stroke-dashoffset 0.5s ease-in-out',
                                transform: 'rotate(-90deg)',
                                transformOrigin: '50% 50%',
                                willChange: 'stroke-dashoffset'
                            }}
                        />
                        {/* Gradient definition — editorial warm orange → gold,
                            matching the home-page / modal accent palette. */}
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#ff5b3b" />
                                <stop offset="55%" stopColor="#ff8a4a" />
                                <stop offset="100%" stopColor="#f8c95a" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                
                {/* Time Display */}
                <div className={`countdown-timer__time ${isAnimating ? 'countdown-timer__time--pulse' : ''}`}>
                    {formatTime(count)}
                </div>
                
            </div>
        </div>
    );
};

export default CountdownTimer;